import api from '../api'

export default {

  accounts: async () => {
    return api.get('api/partner-account/accounts')
  },

  invoices: async (id,page, take, sortBy, sortOrder, search, filters) => {
    return api.get(`api/partner-account/${id}/invoices?page=${page}&take=${take}&sort_by=${sortBy}&sort_order=${sortOrder}&search=${search}&filters=${filters}`)
  },

  payments: async (id,page, take, sortBy, sortOrder, search, filters) => {
    return api.get(`api/partner-account/${id}/payments?page=${page}&take=${take}&sort_by=${sortBy}&sort_order=${sortOrder}&search=${search}&filters=${filters}`)
  },

  credits: async (id,page, take, sortBy, sortOrder, search, filters) => {
    return api.get(`api/partner-account/${id}/credits?page=${page}&take=${take}&sort_by=${sortBy}&sort_order=${sortOrder}&search=${search}&filters=${filters}`)
  },

  debits: async (id,page, take, sortBy, sortOrder, search, filters) => {
    return api.get(`api/partner-account/${id}/debits?page=${page}&take=${take}&sort_by=${sortBy}&sort_order=${sortOrder}&search=${search}&filters=${filters}`)
  },

  accountStatement: async (id,from,to) => {
    return api.get(`api/partner-account/${id}/statement?from=${from}&to=${to}`)
  },

 



}
